import { Routes } from '@angular/router';
import { sessionGuard } from './core/guards/session.guard';
import { requiredParamGuard } from './core/guards/required-param.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'onboarding',
    pathMatch: 'full',
  },
  {
    path: 'onboarding',
    loadComponent: () => import('./pages/auth/onboarding/onboarding.page').then(m => m.OnboardingPage)
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/auth/register/register.page').then(m => m.RegisterPage)
  },
  {
    path: 'app',
    canActivate: [sessionGuard],
    children: [
      {
        path: 'kiosk',
        loadComponent: () => import('./pages/home/kiosk/kiosk.page').then(m => m.KioskPage)
      },
      {
        path: 'clock-in',
        canActivate: [requiredParamGuard('employee')],
        loadComponent: () => import('./pages/home/clock-in/clock-in.page').then(m => m.ClockInPage)
      },
      {
        path: 'add-clock-in',
        loadComponent: () => import('./pages/home/add-clock-in/add-clock-in.page').then(m => m.AddClockInPage)
      },
      {
        path: 'admin-access',
        loadComponent: () => import('./pages/settings/admin-access/admin-access.page').then(m => m.AdminAccessPage)
      },
      {
        path: 'settings',
        canActivate: [requiredParamGuard('admin')],
        loadComponent: () => import('./pages/settings/settings/settings.page').then(m => m.SettingsPage)
      },
    ]
  },
  {
    path: 'home',
    redirectTo: 'onboarding',
  },
  {
    path: '**',
    redirectTo: 'onboarding',
  },
];
